var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManageSolutions = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Component 44 \\u2013 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1604",
  fill: "none",
  d: "M0 0h100v100H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Search results for Manage - Flaticon-3"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8535",
  transform: "translate(1.573 1.573)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 259",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M23.149 12.147h-7.857"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9331",
  d: "M8.922 12.147H0v69.315h63.476",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9332",
  d: "M73.705 12.147h23.15v69.315H69.846",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9333",
  d: "M90.801 39.505v29.811H6.053V18.16h20.411",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9334",
  d: "M70.39 18.16h20.411v14.975",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 260",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M45.4 75.409h6.053"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4619",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M42.374 81.462h12.107v9.339H42.374z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4620",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M30.267 90.801h36.32v6.053h-36.32z"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 92",
  cx: 19.499,
  cy: 19.5,
  rx: 19.499,
  ry: 19.5,
  transform: "rotate(-11.245 95.911 -121.324)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9335",
  d: "M80.126 35.954v-8.511l-7.171-1.851a25.12 25.12 0 0 0-2.866-6.92l3.762-6.379-6.018-6.018-6.379 3.762a25.12 25.12 0 0 0-6.92-2.866L52.687 0h-8.511l-1.851 7.171a25.119 25.119 0 0 0-6.92 2.866l-6.379-3.762-6.018 6.018 3.762 6.379a25.12 25.12 0 0 0-2.866 6.92l-7.171 1.851v8.511l7.171 1.851a25.12 25.12 0 0 0 2.866 6.92L23.004 51.1l6.018 6.018 6.379-3.762a25.119 25.119 0 0 0 6.92 2.866l1.851 7.171h8.515l1.851-7.171a25.119 25.119 0 0 0 6.92-2.866l6.379 3.762 6.018-6.018-3.768-6.375a25.12 25.12 0 0 0 2.866-6.92Z",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8534"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9336",
  d: "M46.914 41.319a3.05 3.05 0 0 1-2.156-.893l-6.053-6.053a3.05 3.05 0 0 1 4.313-4.313l3.567 3.567 6.97-9.294a3.05 3.05 0 0 1 4.88 3.66L49.355 40.1a3.05 3.05 0 0 1-2.224 1.212c-.073.001-.143.007-.217.007Z",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 261",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.107 51.454h6.053"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 262",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.107 57.507h9.08"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 263",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.107 63.397h18.16"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 264",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M84.747 51.454h-6.053"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 265",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M84.747 57.507h-9.08"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 266",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M84.747 63.561H66.66"
})))));
export default SvgManageSolutions;